// extracted by mini-css-extract-plugin
export default {"Map":"Map_Map__2demJ","Map__title":"Map_Map__title__24dWN","Map__order":"Map_Map__order__5aupk","Map__right":"Map_Map__right__3r7fE","Map__left":"Map_Map__left__20x7p"};